module.exports = __webpack_public_path__ + "media/entities/1503-12227f65.png";